<template>
    <div>
        <div class="p-2 d-flex justify-content-between">
            <div class="d-flex"><div class="mx-1"><img :src="user.profileImg" class="profile-img" v-if="user.profileImg"/>
            <img
              class="profile-img"
              v-else
              :src="`https://avatars.dicebear.com/api/initials/${user.name}.svg`"
              alt="employee image"
            />
            </div>
            <div class="my-2 mx-1"><p class="employee-title">{{ user.name }}</p></div>
            </div>
            <div><Button class="qb-btn qb-btn-black-sm mt-2" label="back" @onClick="back()" /></div>
        </div>
        <hr class="my-0" />
        <DropDown
            label="Select Evaluation Template *"
            :selectLabel="selectedTemplate.name || 'search template'"
            placeholder="Enter Template Name to search"
            @callBackValue="handleTemplateChange"
            v-model="templateSearchTerm"
            :items="templatelabels"
            class="my-1 col-5"
        />
        
        <!-- <Button label="Add" class="qb-btn qb-btn-primary-sm mt-2 d-flex" @onClick="addTemplate()"/> -->
        <div v-if="selectedTemplate.name" class="my-2">
            <div class="evaluation-box">
                <table>
                    <tbody>
                         <tr v-for="(template, index) in selectedTemplateData" :key="index" class="">
                            <td><div class="input-box mb-2"><p class="reporter-title">{{template.name}}*</p></div></td>
                            <td><div class="input-box mb-2"><Input  v-model="template.score"  type="number"/></div></td>
                     </tr>
                    </tbody>
                </table>
           
            
            <TextArea v-model="comment" label="Comments *" placeholder="Comments on score" class="mt-2"/>
            </div>
            <div class="mt-3 d-flex justify-content-between">
            
            <Button class="qb-btn qb-btn-primary-md mt-2" label="submit" @onClick="evaluateData()" />
            </div>
        </div>
        <div v-else class="d-flex justify-content-center">
                <div class="info d-flex gap-3 p-3 mt-2 mb-0 align-items-center justify-content-center">
                    <div><font-awesome-icon icon="fa-solid fa-circle-exclamation" /></div>
                    <p class="my-0 fade-text">Select any Template to assign scores</p>
                </div>
            </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters: trainingMapGetters, mapActions: trainingMapActions } = createNamespacedHelpers('Training');
const {  mapActions: workSheetMapActions } = createNamespacedHelpers('WorkSheet');
const {mapGetters:authMapGetters} = createNamespacedHelpers('Auth');
import DropDown from '../components/DropDownSearchComponent.vue';
import Input from '../components/TextFieldComponent.vue';
import TextArea from "../components/TextAreaComponent.vue"
import Button from '../components/ButtonComponent.vue';
import Vue from 'vue'
export default {
    name: 'EvaluationComponent',
    data() {
        return {
            selectedTemplate: {
                name: '',
                value: '',
            },
            comment:'',
        selectedTemplateData:[],
            templateSearchTerm: '',
            taskEvaluationList: [
                {
                    rowName: '',
                    score: '',
                    comments: '',
                },
            ],
        };
    },
    components: {
        Button,
        Input,
        DropDown,
        TextArea
    },
    methods: {
        ...trainingMapActions({
            getAllTemplate: 'GET_ALL_TEMPLATE',
            setTemplate: 'SET_TEMPLATE_DATA',
            getUserEvaluation:'SET_USER_IN_EVALUATION',
             getUsersForEnrolledTraining: 'GET_USERS_FOR_ENROLLED_TRAINING',
        }),
         ...workSheetMapActions({
            getTaskScoreForUser:'GET_TASK_SCORE'
        }),
        addTemplate() {
            this.taskEvaluationList.push({
                rowName: '',
                score: '',
                comments: '',
            });
        },
        handleTemplateChange({ label, value }) {
            this.selectedTemplate.name = label;
            this.selectedTemplate.value = value;
            this.selectedTemplateData=[]
            this.alltemplate.map((template)=>{
                if(template.id==this.selectedTemplate.value){
                    for(let i in template.rowLabels)
                    this.selectedTemplateData.push({name:template.rowLabels[i],score:null})
                }
            })
            // this.getAllTemplate(); //pass req. params

        },
        evaluateData() {
            // alert("mk")
            let score={}
            this.selectedTemplateData.map((data)=>{
                score[data.name]=data.score
            })
            // alert(this.$route.params.trainingId)
            let payload = {
                userId: this.user.id,
                trainingId: this.$route.params.trainingId,
                templateId: this.selectedTemplate.value,
                templateModelName: this.selectedTemplate.name,
                score,
                comment:this.comment,

            };
            
            if(this.validate()){
            this.setTemplate({ payload ,
            adminId:this.loggedInUser.userId,
            successCallback:({data})=>{
                if(data.status==='OK'){
                Vue.$toast.success("Score saved successfully")
                }
                if(data.status==='ERROR'){
                Vue.$toast.error(data.message)
                }
                this.getUserEvaluation({payload:null})
                this.getUsersForEnrolledTraining({ id: this.$route.params.trainingId });
            },
            errorCallback:(err)=>{
                console.log(err)
            }});}
            else{
                Vue.$toast.error("Enter All Fields ")
            }
        },
        validate(){
            return (this.comment && this.selectedTemplateData.map((data)=>{
                if(data.score==null)
                return false
            }))
        },
        validateScore(){

        },
        back(){
            this.getUserEvaluation({payload:null})
        }
    },
    computed: {
        ...trainingMapGetters({
            alltemplate: 'getAllTemplate',
            templatelabels: 'getTemplateLabels',
            user: 'getUserInEvaluation',
        }),
        ...authMapGetters({
      loggedInUser: "getUser",
    }),
    },
    watch: {
            templateSearchTerm(name){
                this.getAllTemplate({name});
            }

    },
    created(){
        this.getAllTemplate({name:''});
        // let payload_data={
        //     userId: this.user.id, trainingId: this.$route.params.trainingId 
        // }
        // console.log(payload,this.loggedInUser.userId)
        this.getTaskScoreForUser({payload:{userId: this.user.id, trainingId: this.$route.params.trainingId },adminId:this.loggedInUser.userId})
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";
.profile-img {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}
.employee-title {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-bottom: 0px;
}
.reporter-title{
    font-size: $font-size-md;
  font-weight: $font-weight-bold;
}
.template-box{
    width:200px
}
.fade-text {
    color: $light-500;
    font-size: $font-size-md;
    font-weight: $font-weight-normal-1;
    margin: 0px;
}
.info {
    background-color: #fff9e9;
    border-radius: 5px;
    width:max-content
}
.fa-circle-exclamation {
    color: #fec12f;
}
.input-box{
    width: 70px;
    max-width:70px;
}
.evaluation-box{
    height:430px;
    overflow:scroll;
}
    </style>
